export enum EntityState {
	Draft = 1,
	Published = 2,
	Archived = 3,
}
